import React, { useEffect } from 'react';
import { Button, Col, Row, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  grantAdminAccess,
  listAllUsers,
  revokeAdminAccess,
} from '../../actions/userActions';
import AdminMainContainer from '../../components/AdminMainContainer';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const AdminUsersScreen = ({ history }) => {
  const dispatch = useDispatch();

  const { loading, users, error } = useSelector(
    (state) => state.usersAdminList
  );

  useEffect(() => {
    dispatch(listAllUsers());
  }, [dispatch]);

  const grantAdmin = (e, userID) => {
    e.preventDefault();
    dispatch(grantAdminAccess(userID));
  };

  const revokeAdmin = (e, userID) => {
    e.preventDefault();
    dispatch(revokeAdminAccess(userID));
  };

  return (
    <AdminMainContainer>
      <Row>
        <Col>
          <h1>Usuários</h1>
        </Col>
      </Row>
      {users.length === 0 && (
        <Message variant='primary'>Ainda não há usuário cadastrado</Message>
      )}
      {error && <Message variant='danger'>{error}</Message>}
      {loading ? (
        <Loader />
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th className='text-center align-middle'>Email</th>
              <th className='text-center align-middle'>Nome</th>
              <th className='text-center align-middle'>Admin</th>
              <th className='d-print-none'></th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => {
              return (
                <tr key={user.id}>
                  <td className='align-middle'>{user.email}</td>
                  <td className='align-middle'>{user.name}</td>
                  <td className='align-middle'>
                    {user.isAdmin ? (
                      <i className='fas fa-check text-success'></i>
                    ) : (
                      <i className='fas fa-times text-danger'></i>
                    )}
                  </td>
                  <td className='d-print-none align-middle'>
                    {user.isAdmin ? (
                      <Button
                        type='button'
                        variant='link'
                        className='p-0 m-0'
                        onClick={(e) => revokeAdmin(e, user.id)}
                      >
                        Remover Admin
                      </Button>
                    ) : (
                      <Button
                        type='button'
                        variant='link'
                        className='p-0 m-0 text-danger'
                        onClick={(e) => grantAdmin(e, user.id)}
                      >
                        Adicionar Admin
                      </Button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}
    </AdminMainContainer>
  );
};

export default AdminUsersScreen;
